import React from "react";
import { useTranslation } from "react-i18next";
import Drawer from "@/components/ui/drawer";
import { formatDateLong } from "@/utils";
import type { CompanyTrainingProfile } from "../types/company-training-profiles.types";
import styles from "./CompanyTrainingProfileDetailDrawer.module.scss";

interface CompanyTrainingProfileDetailDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  profile: CompanyTrainingProfile | null;
}

const CompanyTrainingProfileDetailDrawer: React.FC<
  CompanyTrainingProfileDetailDrawerProps
> = ({ isOpen, onClose, profile }) => {
  const { t } = useTranslation();

  if (!profile) return null;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      title={t("companyTrainingProfiles.detail.title")}
      width="520px"
    >
      <div className={styles.content}>
        <div className={styles.field}>
          <span className={styles.fieldLabel}>
            {t("companyTrainingProfiles.fields.companyName")}
          </span>
          <span className={styles.fieldValue}>{profile.companyName}</span>
        </div>

        <div className={styles.field}>
          <span className={styles.fieldLabel}>
            {t("companyTrainingProfiles.fields.contactPhoneNumber")}
          </span>
          <span className={styles.fieldValue}>
            {profile.contactPhoneNumber}
          </span>
        </div>

        <div className={styles.field}>
          <span className={styles.fieldLabel}>
            {t("companyTrainingProfiles.fields.trainingsTaken")}
          </span>
          <div className={styles.chipList}>
            {profile.trainingsTaken.map((item, idx) => (
              <span key={idx} className={styles.chip}>
                {item}
              </span>
            ))}
          </div>
        </div>

        <div className={styles.field}>
          <span className={styles.fieldLabel}>
            {t("companyTrainingProfiles.fields.traineeEvaluations")}
          </span>
          <div className={styles.chipList}>
            {profile.traineeEvaluations.map((item, idx) => (
              <span key={idx} className={styles.chip}>
                {item}
              </span>
            ))}
          </div>
        </div>

        <div className={styles.field}>
          <span className={styles.fieldLabel}>
            {t("common.createdAt")}
          </span>
          <span className={styles.fieldValue}>
            {profile.createdAt ? formatDateLong(profile.createdAt) : "—"}
          </span>
        </div>

        <div className={styles.field}>
          <span className={styles.fieldLabel}>
            {t("common.updatedAt")}
          </span>
          <span className={styles.fieldValue}>
            {profile.updatedAt ? formatDateLong(profile.updatedAt) : "—"}
          </span>
        </div>
      </div>
    </Drawer>
  );
};

export default CompanyTrainingProfileDetailDrawer;
